import React, { useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import useFetch from '../../CustomHooks/useFetch';
import { getCookie } from '../../Util/Cookie';
import { makeStyles } from '@material-ui/core/styles';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { GlobalContext } from '../../Contexts/GlobalContext';
import {capitalizeFirstLetter} from '../../Util/StringFunctions';

function Categories() {
  const globalContext = useContext(GlobalContext);
  const [getCategoriesResponse, getCategoriesHook] = useFetch();
  const [addCategoryResponse, addCategoryHook] = useFetch();
  const [editCategoryResponse, editCategoryHook] = useFetch();
  const [deleteCategoryResponse, deleteCategoryHook] = useFetch();
  const [setCategoryOrderHookResponse, setCategoryOrderHook] = useFetch();
  const classes = useStyles();
  const [translateGui] = useGuiTranslations();

  const [state, setState] = React.useState({
    columns: [
      {
        title: 'Category Name',
        field: 'categoryName'
      },
      {
        type: 'boolean',
        title: 'Available',
        field: 'openToSales',
        initialEditValue: true,
      },
    ],
    data: [
      /*{ categoryName: 'Cold Starters',
        openToSales: true,
      },
      { categoryName: 'Charcoal Grills', 
        openToSales: false,
      },
      { categoryName: 'Soft Drinks', 
      openToSales: true,
      },*/
    ],
  });


  function getCategories() {

    globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...' , showButton: false } });
    getCategoriesHook(
      {
        url: '/admin/categories?PageNumber=1&PageSize=10',
        addTokenHeader: true,
        //headers: [{ name: 'Authorization', value: 'Bearer ' + getCookie('token') }],
        method: 'GET',
        postData: null,
      }
    )
  }

  useEffect(
    () => {
      let categoryArr = [];
      console.log(getCategoriesResponse);
      if (getCategoriesResponse.length != 0 && getCategoriesResponse) {
        getCategoriesResponse.categories.map(
          e => categoryArr.push({ categoryName: e.title, openToSales: e.isAvailable, categoryID: e.id })
        )

        setState(
          {
            ...state, data: categoryArr,
          }
        )
      }
      //globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
    }, [getCategoriesResponse]
  )



  useEffect(
    () => {
      getCategories();

      globalContext.dispatchMethod(
        {
          type: 'SET_MENU_LOCATION',
          value: {
            a: 4,
            b: 5
          },
        }
      )

    }
    , []
  )


  const addCategory = async (newData) => {
    addCategoryHook(
      {
        url: '/admin/categories',
        method: 'POST',
        postData: {
          title: newData.categoryName,
          type: "Food",
          description: "string",
          isAvailable: newData.openToSales,
        },
        headers: [{ name: 'Authorization', value: 'Bearer ' + getCookie('token') }]
      }
    )
  }

  useEffect(
    () => {
      //console.log(addCategoryResponse);
      if (addCategoryResponse.length != 0 && addCategoryResponse) {
        //console.log('okmis');
        getCategories();
      }
    }
    , [addCategoryResponse]
  )


  const editCategory = async (newData, oldData) => {
    editCategoryHook(
      {
        url: '/admin/categories/' + oldData.categoryID,
        method: 'PUT',
        postData: {
          title: newData.categoryName,
          type: "Food",
          description: "string",
          isAvailable: newData.openToSales,
        },
        headers: [{ name: 'Authorization', value: 'Bearer ' + getCookie('token') }]
      }
    )
  }

  useEffect(
    () => {
      //console.log(addCategoryResponse);
      if (editCategoryResponse.length != 0 && addCategoryResponse) {
        //console.log('okmis');
        getCategories();
      }
    }
    , [editCategoryResponse]
  )

  useEffect(
    () => {
      //window.gtag('config', 'UA-160225157-2', { 'page_path': '/Categories' });
    }, []
  )

  const deleteCategory = async (oldData) => {
    deleteCategoryHook(
      {
        url: '/admin/categories/' + oldData.categoryID + '?softDelete=true',
        method: 'DELETE',
        postData: {
          softDelete: 'true',
        },
        headers: [{ name: 'Authorization', value: 'Bearer ' + getCookie('token') }]
      }
    )
  }

  useEffect(
    () => {
      //console.log(addCategoryResponse);
      if (deleteCategoryResponse.length != 0 && deleteCategoryResponse) {
        //console.log('okmis');
        getCategories();
      }
    }
    , [deleteCategoryResponse]
  )


  const changeCategoryOrder = (categoryId, direction) => {
    console.log(categoryId + direction);
    setCategoryOrderHook(
      {
        url: `/admin/categories/${categoryId}/move/${direction}`,
        method: 'PUT',
        addTokenHeader: true,
      }
    )
  }

  useEffect(
    () => {
      console.log(setCategoryOrderHookResponse);
      if (setCategoryOrderHookResponse.success != null) {
        getCategories();
      }
    }, [setCategoryOrderHookResponse]
  )


  useEffect(
    () => {
      let colsArr = [...state.columns];
      colsArr[0].title = capitalizeFirstLetter(translateGui(34));
      colsArr[1].title = capitalizeFirstLetter(translateGui(33));
      setState(
        {
          ...state, columns: colsArr,
        }
      )
    }, [globalContext.globalState.selectedGuiLanguage]
  )

  return (
    <div className={classes.root}>
      <MaterialTable
        className={classes.addButton}
        options={{ paging: false, search: false }}
        title={translateGui(5).charAt(0).toUpperCase() + translateGui(5).slice(1)}
        columns={state.columns}
        data={state.data}
        editable={{
          onRowAdd: newData => new Promise((resolve, reject) => { addCategory(newData); resolve() }),
          onRowUpdate: (newData, oldData) => editCategory(newData, oldData),
          onRowDelete: oldData => new Promise((resolve, reject) => { deleteCategory(oldData); resolve() }),
        }}
        actions={[
          {
            icon: ArrowUpwardIcon,
            tooltip: translateGui(119),
            onClick: (event, rowData) => changeCategoryOrder(rowData.categoryID, 'Up')
          },
          {
            icon: ArrowDownwardIcon,
            tooltip: translateGui(118),
            onClick: (event, rowData) => changeCategoryOrder(rowData.categoryID, 'Down')
          },
        ]}
        localization={{
          header: {
            actions: capitalizeFirstLetter(translateGui(35)),
            
          },
          body: {
            emptyDataSourceMessage: 'No records to display',
            editRow: { deleteText: translateGui(114) } ,
            addTooltip: translateGui(115),
            deleteTooltip: translateGui(116),
            editTooltip: translateGui(117),
          },
          

        }}
      />
    </div>
  );
}
export default Categories;

const useStyles = makeStyles({
  root: {
    '& span>button': {
      color: "#5dbcd2",
      fontSize: "60px",
    }
  },
  addButton: {
    '& .MuiToolbar-root span': {
      fontSize: '2rem',
    }
  }

});